var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoneiumDarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#1a1a1a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5c0-1.5 1-2.5 2.5-2.5h2c1.5 0 2.5 1 2.5 2.5s-1 2.5-2.5 2.5h-2c-1.5 0-2.5-1-2.5-2.5z",
    fill: "#0070f3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5c0-1.5 1-2.5 2.5-2.5h2c1.5 0 2.5 1 2.5 2.5s-1 2.5-2.5 2.5h-2c-1.5 0-2.5-1-2.5-2.5z",
    fill: "#0070f3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.5c0-1.5 1-2.5 2.5-2.5h2c1.5 0 2.5 1 2.5 2.5s-1 2.5-2.5 2.5h-2c-1.5 0-2.5-1-2.5-2.5z",
    fill: "#0070f3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoneiumDarkCircle);
export default __webpack_public_path__ + "static/media/SoneiumDarkCircle.d5fdb1649d62b45b99273e7e6888b440.svg";
export { ForwardRef as ReactComponent };